import axios from 'axios';

// In production we usually serve the frontend and backend under the same origin
// and route API calls via `/api`. For local/dev (or special environments),
// you can override this with `REACT_APP_API_BASE_URL`, e.g.
// `http://localhost:5001/api`.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// リクエストインターセプター（デバッグ用）
api.interceptors.request.use(
  (config) => {
    console.log('API Request:', config.method?.toUpperCase(), config.url, config.baseURL + config.url);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// レスポンスインターセプター（エラーハンドリング）
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('API Error:', error.response?.status, error.config?.url, error.message);
    
    if (error.response?.status === 401) {
      // 認証不要のエンドポイントではリダイレクトしない
      const url = error.config?.url || '';
      const publicEndpoints = ['/auth/login', '/auth/google', '/auth/google/callback', '/health'];
      const isPublicEndpoint = publicEndpoints.some(endpoint => url.includes(endpoint));
      
      if (!isPublicEndpoint) {
        // 認証エラーの場合、トークンを削除してログインページにリダイレクト
        localStorage.removeItem('token');
        delete api.defaults.headers.common['Authorization'];
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
